<template>
    <div class="customer-flow-pop">
        <div class="customer-flow-pop-mask" v-if="showCustomerFlow" @click="close"></div>
        <div class="customer-flow-pop-box" v-if="showCustomerFlow">
            <div class="box">
                <div class="title">今日客流</div>
                <div class="header">
                    <div class="tit">景点</div>
                    <div class="tit">客流趋势</div>
                </div>
                <div class="list">
                    <div class="item" v-for="(item, index) in list" :key="item.id">
                        <div class="item-tit">
                            <div class="name">{{ item.region_name }}</div>
                            <div class="num"><span>{{ item.enter_num | formatNumberWithCommas }}</span><span>人</span></div>

                        </div>
                        <div class="item-content" :id="'customerFlow' + index">
                            
                        </div>
                    </div>
                </div>


                <img class="close" src="@/assets/new-style/icon_close@2x.png" alt="" @click="close">
            </div>
        </div>
    </div>
</template>

<script>
// import { Toast } from 'mint-ui'
import Apis from '../../config/apis'
// import _ from '../../config/util'
import * as echarts from 'echarts'
export default {
    props: {
        showCustomerFlow: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            list: []
        }
    },
    watch: {
        // isWeiXin() {
        //     return this.$store.state.isWeiXin
        // },
        showCustomerFlow(val) {
            if(val) {
                this.getData()
            }
        }
    },
    filters: {
        formatNumberWithCommas(number) {
            // 将数字转换为字符串，并使用正则表达式添加千位分隔符
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
    },
    methods: {
        close() {
            this.$emit('update:showCustomerFlow', false)
        },
        getData() {
            this.axios.post(Apis.visitor).then((res) => {
                this.list = res.data
                this.$nextTick(() => {
                    this.list.forEach((v, i) => {
                        this.initEcharts(i)
                    })
                })
            })
            
            // this.list = [{},{}]
            // this.$nextTick(() => {
            //     this.initEcharts(0)
            //     this.initEcharts(1)
            // })
        },
        initEcharts(idx) {
            // let data = {
            //     xData: ['08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00'],
            //     list: [{
            //         value: [100, 120, 130, 70, 120, 90, 20]}
            //     ]
            // }
            let item = this.list[idx]
            let data = {
                xData: item.data.map(v => v.date),
                list: [
                    {
                        value: item.data.map(v => v.enter_num)
                    }
                ]
            }
            let colors = ['158, 190, 187']

            let finallData = data.list.map((el, ix) => {
                let item = this.getFixedData(el.name, ix < 2 ? colors[ix] : this.getRandomColor(), el.value)
                return item
            })

            var myChart = echarts.init(document.getElementById(`customerFlow${idx}`))
            let option = {
                // colors,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    textStyle: {
                        color: '#fff',
                        fontSize: 13,
                        lineHeight: -2
                    },
                    itemGap: 20,
                    right: '20%',
                    formatter (param) {
                        return '\r' + param.split('').join('') + '\n'
                    },
                    icon: 'reat',
                    itemWidth: 10,
                    itemHeight: 10
                },
                grid: {
                    width: '80%',
                    height: '80%',
                    top: 0,
                    bottom: 0,
                    left: 20,
                    right: 0,
                    containLabel: true
                },
                xAxis: [
                    // x轴大刻度
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: data.xData,
                        position: 'bottom',
                        offset: 7,
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: '#2D3C5C'
                            }
                        },
                        axisLabel: {
                            color: '#909090',
                            show: true
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: ['rgba(45, 60, 92, 0)']
                            }
                        },
                        axisTick: {show: false}
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: '#2D3C5C'
                            }
                        },
                        axisLabel: {
                            color: '#FFFFFF',
                            show: false
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: ['rgba(45, 60, 92, .3)']
                            }
                        }
                    }
                ],
                series: finallData
            }
            myChart.setOption(option)
        },
        getRandomColor () {
            let r = Math.floor(Math.random() * 256)
            let g = Math.floor(Math.random() * 256)
            let b = Math.floor(Math.random() * 256)
            return `${r},${g},${b}`
        },
        getFixedData (name, color, value) {
            return {
                name: name,
                type: 'line',
                smooth: true,
                showSymbol: false,
                lineStyle: {
                    color: '#2A5955'
                },
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                        offset: 0,
                        // color: 'rgba(22, 112, 0, .7)'
                        color: `rgba(${color}, 0.5)`
                        },
                        {
                        offset: 1,
                        // color: 'rgba(22, 112, 0, .1)'
                        // color: 'rgba(0, 0, 0, 0)'
                        color: `rgba(${color}, .1)`
                        // color: color100,
                        }
                    ])
                },
                data: value,
                emphasis: { focus: 'series' }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.customer-flow-pop {
    --default-z-index: 10000;
    line-height: 1;
    .customer-flow-pop-mask {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: .5);
        z-index: var(--default-z-index);
    }
    .customer-flow-pop-box {
        line-height: 1;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: linear-gradient(180deg, #206864 0%, #67BBA6 100%);
        border-radius: .29rem;
        padding: .1rem .12rem;
        z-index: var(--default-z-index);
        .box {
            width: 6.7rem;
            background: #FFFFFF;
            border-radius: .29rem;
            padding: .3rem;
            text-align: center;
            position: relative;

            .title {
                font-weight: 600;
                font-size: .32rem;
                color: #212121;
            }
            .header {
                display: flex;
                height: .46rem;
                line-height: .46rem;
                border-radius: .23rem;
                background: rgba($color: #206864, $alpha: .1);
                margin-top: .42rem;
                .tit {
                    font-weight: 400;
                    font-size: .26rem;
                    color: #666666;
                    flex: 1;
                }
            }
            .list {
                max-height: 60vh;
                overflow-y: auto;
                .item {
                    display: flex;
                    margin-top: .3rem;
                    margin-bottom: .6rem;
                    .item-tit {
                        flex: 4;
                        position: relative;
                        text-align: left;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        box-sizing: border-box;
                        padding-left: .4rem;
                        .name {
                            font-weight: 500;
                            font-size: .26rem;
                            color: #206864;
                        }
                        .num {
                            font-weight: 600;
                            font-size: .48rem;
                            color: #212121;
                            margin-top: .2rem;
                            span:nth-child(2) {
                                font-size: .26rem;
                                font-weight: 500;
                            }
                        }
                        &::before {
                            position: absolute;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            content: '';
                            width: .08rem;
                            height: 1.10rem;
                            background: #67BBA6;
                            border-radius: .04rem;
                        }
                    }
                    .item-content {
                        flex: 6;
                        height: 1.3rem;
                    }
                }
            }

            .close {
                position: absolute;
                width: .58rem;
                height: .58rem;
                left: 50%;
                bottom: -.50rem;
                transform: translate(-50%, 100%);
            }
        }
    }
}
</style>